import { createFileRoute, redirect } from '@tanstack/react-router';

// The tenant-templates surface lives on the Library page's "My templates" tab now; this legacy
// index route redirects there so old links keep working. The templates/$templateId editor is untouched.
export const Route = createFileRoute('/_authenticated/_app/inspection/templates/')({
	beforeLoad: () => {
		throw redirect({ to: '/inspection/library', search: { tab: 'tenant' } });
	},
});
